export default "__VITE_ASSET__DxHR7KWr__"